import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { setMap } from "../../actions/testcenterActions";

class TestCenter extends Component {
  clickCard = (coordinates) => {
    var new_coords = [coordinates[0], coordinates[1] - 0.01];
    this.props.setMap(new_coords);
    window.scrollTo(0, 0);
  };
  render() {
    const {
      name,
      location,
      permanentLocation,
      datePopUp,
      timeOfEvent,
      past,
      appointment,
      schedule,
      registLink,
      registPhone,
      resultPhone,
      coordUrl,
    } = this.props.testcenter;
    const { coordinates } = this.props.testcenter.location;

    const getDirections = `https://www.google.com/maps/dir//${coordinates[1]},${coordinates[0]}/`;

    if (permanentLocation) {
      var permLoc = "Regional Public Testing Location";
      var cardStyle = "card mb-2 border-left-permanent";
      var color = { color: "#e74c3c" };
    } else if (!past) {
      permLoc = "Non-Regional Testing Location / Pop-Up Event";
      cardStyle = "card mb-4 border-left-popup";
      color = { color: "#475ccc" };
    } else {
      permLoc = "Non-Regional Testing Location / Past Event";
      cardStyle = "card mb-4 border-left-past";
      color = { color: "#9196ae" };
    }
    return (
      <div
        style={{ cursor: "pointer" }}
        className={cardStyle}
        onClick={() => this.clickCard(coordinates)}
      >
        <div className="card-body">
          <h4 className="card-title">{name}</h4>
          <h6 className="card-subtitle mb-2 text-muted">{permLoc}</h6>
          <h6 className="card-text mb-2">
            <i style={color} className="fas fa-map-marker-alt mr-2"></i>
            {location.formattedAddress}
          </h6>
          {!permanentLocation ? (
            <Fragment>
              <h6 className="card-text mb-2">
                <i style={color} className="far fa-calendar-alt mr-2"></i>
                Date of Event: {datePopUp}
              </h6>
              <h6 className="card-text mb-2">
                <i style={color} className="far fa-clock mr-2"></i>
                Time of Event: {timeOfEvent}
              </h6>
            </Fragment>
          ) : null}
          <a
            style={{
              color: "#212529",
              fontSize: "16px",
              textDecoration: "underline",
            }}
            href={coordUrl}
            target="_blank"
            className="card-link"
          >
            <i style={color} className="fas fa-map-marked-alt mr-2"></i>
            Get directions
          </a>
          {appointment ? (
            <>
              <p className="mb-0">
                <i style={color} className="far fa-calendar-check mr-2"></i>
                Appointment Required
              </p>
              <ul>
                {registLink ? (
                  <li>
                    Registration:{" "}
                    <a
                      style={{
                        color: "#212529",
                        fontSize: "16px",
                        textDecoration: "underline",
                      }}
                      target="_blank"
                      className="card-link"
                      href={registLink}
                    >
                      Website
                    </a>
                  </li>
                ) : null}
                {resultPhone && registLink ? (
                  <li>
                    Results:{" "}
                    <a
                      style={{
                        color: "#212529",
                        fontSize: "16px",
                        textDecoration: "underline",
                      }}
                      target="_blank"
                      className="card-link"
                      href={`tel:${resultPhone}`}
                    >
                      {`(${resultPhone[0]}${resultPhone[1]}${resultPhone[2]})-${resultPhone[3]}${resultPhone[4]}${resultPhone[5]}-${resultPhone[6]}${resultPhone[7]}${resultPhone[8]}${resultPhone[9]}`}
                    </a>
                  </li>
                ) : null}
                {registPhone && !registLink ? (
                  <li>
                    Registration & Results:{" "}
                    <a
                      style={{
                        color: "#212529",
                        fontSize: "16px",
                        textDecoration: "underline",
                      }}
                      target="_blank"
                      className="card-link"
                      href={`tel:${registPhone}`}
                    >
                      {`(${registPhone[0]}${registPhone[1]}${registPhone[2]})-${registPhone[3]}${registPhone[4]}${registPhone[5]}-${registPhone[6]}${registPhone[7]}${registPhone[8]}${registPhone[9]}`}
                    </a>
                  </li>
                ) : null}
              </ul>
            </>
          ) : null}
          {schedule.length > 0 ? (
            <Fragment>
              <p className="mb-0">
                <i style={color} className="far fa-clock mr-2"></i>
                Schedule:
              </p>
              <ul>
                {schedule.map((data, i) => (
                  <li key={i}>
                    {data.daysOfWeek} - {data.timesOfDay}
                  </li>
                ))}
              </ul>
            </Fragment>
          ) : null}
        </div>
      </div>
    );
  }
}

TestCenter.propTypes = {
  testcenter: PropTypes.object.isRequired,
  setMap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  zoom: state.testcenter.zoom,
  center: state.testcenter.center,
});

export default connect(mapStateToProps, {
  setMap,
})(TestCenter);
